import http from "@/http-common";

const BASE = "statistics/album";

class AlbumStatisticsService {
  getOverview(params) {
    return http.get(`${BASE}/overview`, { params });
  }

  getItems(params) {
    return http.get(`${BASE}/items`, { params });
  }

  approve(albumIdx) {
    return http.put(`album-v2/${encodeURIComponent(albumIdx)}/approval`, { approved: true });
  }
}

export default new AlbumStatisticsService();
